import './App.css';
import React from 'react';
import Operateurs from './operateurs.js';
import ListDevis from './listDevis.js';
import TabBar from './tabBar.js'
import LoginBox from './loginBox.js'
import FrontOverlay from './frontOverlay';
import Sponsors from './sponsors.js';

class App extends React.Component {
    
  constructor(props) {
      super(props);
      this.state = {
          tab:'Devis',
          login:false,
          operator:false,
          searchName:'',
          filterName:'',
          searchTelephone:'',
          searchApporteur:[],
          filterTelephone:'',
          searchSelf:false,
          searchStatus:[],
          searchStatusProcess:[],
          searchNoSolly:true,
          startDate:0,
          endDate:0,
          startDateModif:0,
          endDateModif:0,
          dateType:'creation',
          searchUser:[],
          searchUnvalidated:false
      }
      props.api.handlerOnConnectedStatus( this.onConnectedStatus.bind(this) )
      this.mounted = false
  }

  componentDidMount() {
    this.mounted = true
    this.props.api.post(
        {action:'get_status'},
        ()=>{}
    )
  }

  setSearchSelf( e ) {
    this.setState({searchSelf:e.target.checked})
  }

  setSearchUnvalidated( e ) {
    this.setState({searchUnvalidated:e.target.checked})
  }

  setDateType( e ) {
    this.setState({dateType:e.target.value})
  }

  setSearchStatus( e ) {
    this.setState({searchStatus:e})
  }

  setSearchStatusProcess( e ) {
    this.setState({searchStatusProcess:e})
  }

  setSearchApporteur( e ) {
    this.setState({searchApporteur:e})
  }

  setStartDate( date ) {
    this.setState({startDate:date})
  }

  setEndDate( date ) {
    this.setState({endDate:date})
  }


  setStartDateModif( date ) {
    this.setState({startDateModif:date})
  }

  setEndDateModif( date ) {
    this.setState({endDateModif:date})
  }

  setSearchUser( e ) {
    this.setState({searchUser:e.map( entry => entry.value )})
  }

  setSearchNoSolly( e ) {
    this.setState({searchNoSolly:e.target.checked})
  }

  onFilter() {
    this.setState({
      filterName:this.state.searchName,
      filterTelephone:this.state.searchTelephone
    })
  }

  renderContent() {
      switch ( this.state.tab ) {
          case 'Opérateurs':
            return <Operateurs container={this} api={this.props.api}/>
          case 'Devis':
            return <ListDevis container={this} operator={this.state.operator} api={this.props.api} filterName={this.state.filterName} filterTelephone={this.state.filterTelephone} searchSelf={this.state.searchSelf} searchUnvalidated={this.state.searchUnvalidated} searchStatus={this.state.searchStatus} searchStatusProcess={this.state.searchStatusProcess} searchUser={this.state.searchUser} searchApporteur={this.state.searchApporteur} searchNoSolly={this.state.searchNoSolly} startDate={this.state.startDate} endDate={this.state.endDate} startDateModif={this.state.startDateModif} endDateModif={this.state.endDateModif} dateType={this.state.dateType}/>
          case 'Quotations':
            return <ListDevis container={this} operator={this.state.operator} api={this.props.api} quotations searchUser={false} searchApporteur={this.state.searchApporteur} startDate={this.state.startDate} endDate={this.state.endDate} searchSelf={this.state.searchSelf}/>
          case 'Affiliés':
            return <Sponsors container={this} api={this.props.api}/>
      }
      return <span>content</span>
  }

  onConnectedStatus(status,operator) {
      if ( this.mounted ) this.setState({'login':status,'operator':operator})
  }

  isAdmin() {
      return this.props.api.isAdmin()
  }

  setTab(tab) {
      this.setState({tab:tab})
  }

  onLogout() {
    this.props.api.disconnect()
  }

  render() {
      const contentClass = ( this.state.tab == 'Affiliés' )?'content_narrow':'content'
      let tabs = ['Devis']
      if ( this.state.operator ) tabs = ['Quotations','Devis','Affiliés']
      if ( this.isAdmin() ) tabs = ['Quotations','Devis','Affiliés','Opérateurs']
      return this.state.login
      ? (<>
        <FrontOverlay api={this.props.api}/>
        <div className="container" >
          <TabBar 
            tabs={tabs}
            tab={this.state.tab} 
            setTab={this.setTab.bind(this)} 
            api={this.props.api} 
          >
            <div className='tab_logout' onClick={this.onLogout.bind(this)}>
                {this.state.login} | Se déconnecter
            </div>
          </TabBar>
          <div className={contentClass}>{this.renderContent()}</div>
        </div>
      </>)
      : <LoginBox api={this.props.api}/>
  }
}

export default App;
